/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_action__back_overview = /** @type {(inputs: {}) => string} */ () => {
	return `Zurück zur Übersicht`
};

const en_action__back_overview = /** @type {(inputs: {}) => string} */ () => {
	return `Back to overview`
};

const es_action__back_overview = /** @type {(inputs: {}) => string} */ () => {
	return `Volver a la vista preliminar`
};

const fr_action__back_overview = /** @type {(inputs: {}) => string} */ () => {
	return `Retour à l'aperçu`
};

const it_action__back_overview = /** @type {(inputs: {}) => string} */ () => {
	return `Torna all’anteprima`
};

const nl_action__back_overview = /** @type {(inputs: {}) => string} */ () => {
	return `Terug naar het overzicht`
};

const pt_action__back_overview = /** @type {(inputs: {}) => string} */ () => {
	return `Voltar à pré-visualização`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const action__back_overview = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.action__back_overview(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("action__back_overview", locale)
	if (locale === "de") return de_action__back_overview(inputs)
	if (locale === "en") return en_action__back_overview(inputs)
	if (locale === "es") return es_action__back_overview(inputs)
	if (locale === "fr") return fr_action__back_overview(inputs)
	if (locale === "it") return it_action__back_overview(inputs)
	if (locale === "nl") return nl_action__back_overview(inputs)
	return pt_action__back_overview(inputs)
};